import { Link } from 'react-router-dom';

const comparisonData = [
  { feature: 'Product Discovery', normal: 'Time consuming', spreadsheet: 'Organized instantly' },
  { feature: 'Category Browsing', normal: 'Difficult to navigate', spreadsheet: 'Structured lists' },
  { feature: 'Product Comparison', normal: 'Manual and tedious', spreadsheet: 'Simple side-by-side' },
  { feature: 'Beginner Experience', normal: 'Confusing process', spreadsheet: 'Easy step-by-step guidance' },
  { feature: 'Shopping Research', normal: 'Scattered across platforms', spreadsheet: 'Centralized in one place' },
  { feature: 'Quality Verification', normal: 'No QC reference', spreadsheet: 'Built-in QC photo guides' },
];

export default function Comparison() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-secondary-700 bg-secondary-100/70 rounded-full mb-4 tracking-wide">
            Comparison
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Normal Searching vs Superbuy Spreadsheet
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            See how organized resources transform your shopping experience
          </p>
        </div>

        <div className="rounded-2xl border border-background-200/80 overflow-hidden bg-background-50">
          {/* Table Header */}
          <div className="grid grid-cols-3 bg-primary-500">
            <div className="px-6 py-4 text-sm font-semibold text-background-50">Feature</div>
            <div className="px-6 py-4 text-sm font-semibold text-background-50 text-center">Normal Searching</div>
            <div className="px-6 py-4 text-sm font-semibold text-background-50 text-center">
              <i className="ri-sparkling-line mr-1"></i>
              Superbuy Spreadsheet
            </div>
          </div>

          {/* Table Body */}
          {comparisonData.map((row, idx) => (
            <div
              key={row.feature}
              className={`grid grid-cols-3 border-b border-background-200/60 ${
                idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
              }`}
            >
              <div className="px-6 py-4 text-sm font-medium text-foreground-800">{row.feature}</div>
              <div className="px-6 py-4 text-sm text-foreground-500 text-center">{row.normal}</div>
              <div className="px-6 py-4 text-sm text-primary-700 font-medium text-center bg-primary-50/50">
                <i className="ri-check-line text-primary-500 mr-1"></i>
                {row.spreadsheet}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/what-is-superbuy-spreadsheet"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-primary-700 bg-primary-50 rounded-full hover:bg-primary-100 transition-colors cursor-pointer"
          >
            Learn More About How It Works
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}